import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: 'هل الرحلات متاحة يومياً من الرياض؟',
    answer: 'نعم، الباقة الاقتصادية متاحة يومياً تقريباً من الرياض إلى مكة المكرمة، بينما تنطلق رحلات VIP كل اثنين وخميس أسبوعياً.',
  },
  {
    question: 'ماذا تشمل باقات العمرة؟',
    answer: 'جميع الباقات تشمل النقل بالباص ذهاباً وعودة والسكن الفندقي. لا تشمل الباقات الوجبات، ولا يتوفر واي فاي في الباصات.',
  },
  {
    question: 'هل توجد رحلات للعائلات؟',
    answer: 'نعم، العائلات تحصل على غرفة خاصة بسعة 4 أسرّة (وبعض الفنادق 5 أسرّة)، بينما يسكن العزاب في غرف مشتركة بسعر اقتصادي.',
  },
  {
    question: 'كيف أحجز مقعدي؟',
    answer: 'عبر نموذج الحجز في الموقع أو مباشرة عبر واتساب على الرقم 0575179602 — يرد عليك فريقنا بالتوفر والسعر وتفاصيل الانطلاق.',
  },
  {
    question: 'هل يمكنني إلغاء الحجز؟',
    answer: 'نعم، يمكنك التواصل معنا عبر واتساب لإلغاء الحجز أو تعديل التفاصيل قبل موعد الانطلاق.',
  },
  {
    question: 'هل الباصات مكيفة ومريحة؟',
    answer: 'نعم، جميع باصاتنا حديثة موديل 2027 مكيفة ومجهزة بمقاعد مريحة. الباص الاقتصادي يتسع لـ 49 مقعداً وباص VIP يتسع لـ 30 مقعداً فقط.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block bg-brown-100 text-brown-700 px-4 py-2 rounded-full text-sm font-cairo font-medium mb-4">
            أسئلة شائعة
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-amiri font-bold text-gray-900 mb-4">
            كل ما تحتاج معرفته
          </h2>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`bg-white rounded-2xl overflow-hidden transition-all duration-300 border ${
                openIndex === index ? 'border-brown-200 shadow-lg' : 'border-gray-100 hover:border-gray-200'
              }`}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-right"
              >
                <span className="text-gray-900 font-cairo font-bold text-lg pr-4">
                  {faq.question}
                </span>
                <ChevronDown
                  className={`w-6 h-6 text-brown-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 pb-6 pr-16">
                  <p className="text-gray-600 font-cairo leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
